import '@/scss/global.scss';
import './Edifice.scss';
import React, { FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { Toaster } from 'sonner';

type EdificeProps = {
    children: ReactNode[];
};

const Edifice: FC<EdificeProps> = ({ children }) => {
    const portalNode =
        document.getElementById('toast-portal-anchor') || document.body;
    return (
        // .Edifice is in /src/index.html as class from #root
        <div className="Edifice_shell">
            <a href="#main-content" className="invisible">
                Zum Inhalt springen
            </a>
            {children}
            {ReactDOM.createPortal(
                <Toaster
                    position="top-center"
                    className="Notify"
                    toastOptions={{
                        unstyled: true,
                        className: 'Notify_item',
                        descriptionClassName: 'Notify_desc',
                        classNames: {
                            actionButton: 'Notify_close',
                            icon: 'Notify_icon',
                        },
                    }}
                />,
                portalNode,
            )}
        </div>
    );
};

export default Edifice;
